import '@google/model-viewer';
/**
 * @typedef {import('@google/model-viewer').ModelViewerElement} ModelViewerElement
 * @typedef {import("../custom-elements/vi-cart").default} ViCart
 * @typedef {import("../custom-elements/vi-product-list-item").default} ViProductListItem
 */

class ORoomleViewer {
	constructor(/** @type {HTMLDivElement} */element) {
		this.element = element;
		/** @type {ModelViewerElement} */
		this.modelViewer = element.querySelector('model-viewer');

		// prevent mouse scrolling
		this.modelViewer.addEventListener('wheel', (event) => {
			if (!(event.metaKey || event.ctrlKey)) {
				event.stopPropagation();
			}
		}, true);

		// Button events
		element.querySelector('button[data-action="request-plan"]')?.addEventListener('click', () => {
			element.querySelector('vi-dialog[data-id="request"]')?.showModal();
		});
		element.querySelector('.a-button[data-action="activate-ar"]')?.addEventListener('click', () => {
			if (this.modelViewer.canActivateAR) {
				this.modelViewer.activateAR();
			} else {
				element.querySelector('vi-dialog[data-id="ar-info"]')?.showModal();
			}
		});
		element.querySelector('.a-button[data-action="show-product-list"]')?.addEventListener('click', () => {
			element.querySelector('vi-dialog[data-id="product-list"]')?.showModal();
		});
		element.querySelector('.a-button[data-action="cart"]')?.addEventListener('click', async (event) => {
			event.target.toggleAttribute('data-loader', true);
			await this.addItemsToCart();
			event.target.toggleAttribute('data-loader', false);
		});
	}

	get items() {
		return [...this.element.querySelectorAll('vi-product-list-item')].map((/** @type {ViProductListItem} */ value) => ({
			id: value.id,
			quantity: value.quantity,
			data: {
				option: value.option?.value ?? null,
			},
		}));
	}

	async addItemsToCart() {
		/** @type {ViCart} */
		const cartElement = document.querySelector('vi-cart');

		const { items } = this;
		// console.log(items);

		/** Cart Response data */
		const responseData = await cartElement.addItems(items);

		const isCartDrawerOpen = cartElement.open();

		if (isCartDrawerOpen === false) {
			/** Cart drawer does not exists => checkout page. */
			this.drawerElement.dispatchEvent(new Event('click'));
		}

		try {
			window._paq?.push(['trackEvent', 'Roomle Viewer', 'Add to cart', document.title, items.length]);
			window._paq?.push(['trackGoal', 4, responseData?.data?.sumNetFloat ?? null]); // Roomle Konfigurator zum Warenkorb
		} catch (error) {
			console.info('tracking error', error);
		}

		return responseData;
	}
}

document.querySelectorAll('.o-roomle-viewer').forEach((_) => new ORoomleViewer(_));
